import { cn } from '@/lib/utils';

export const ActiveDot = ({
  className,
  absolute,
}: {
  className?: string;
  absolute?: boolean;
}) => {
  return (
    <span
      className={cn(
        'size-1.5 rounded-full bg-brand-jordy-blue',
        {
          'absolute right-0 top-0': absolute,
        },
        className
      )}
    />
  );
};
